import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function UserDetails() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [address, setAddress] = useState(null);
  const [userRequirements, setUserRequirements] = useState([]);
  const [visitDetails, setVisitDetails] = useState([]);
  const [tokenDetails, setTokenDetails] = useState([]); // Assuming you have token details
  const [properties, setProperties] = useState([]);

  const handleGenerateReceipt = (token) => {
    // Placeholder for receipt generation logic

    // Implement your receipt generation logic here, e.g., creating a PDF or navigating to a receipt page
  };
  useEffect(() => {
    fetch("/dummy_data/user.json")
      .then((response) => response.json())
      .then((data) => {
        const userData = data.find((user) => user.id === parseInt(id, 10));
        setUser(userData);

        if (userData) {
          fetch("/dummy_data/address.json")
            .then((response) => response.json())
            .then((addressData) => {
              const userAddress = addressData.find(
                (address) => address.id === userData.addressId
              );
              setAddress(userAddress);
            })
            .catch((error) => console.error("Error fetching address:", error));

          fetch("/dummy_data/user_requirements.json")
            .then((response) => response.json())
            .then((requirementsData) => {
              const matchedRequirements = requirementsData.filter(
                (requirement) => requirement.userId === userData.id
              );
              setUserRequirements(matchedRequirements);
            })
            .catch((error) =>
              console.error("Error fetching user requirements:", error)
            );

          fetch("/dummy_data/user_property.json")
            .then((response) => response.json())
            .then((visitData) => {
              const matchedVisits = visitData.filter(
                (visit) => visit.userId === userData.id
              );
              setVisitDetails(matchedVisits);
            })
            .catch((error) =>
              console.error("Error fetching visit details:", error)
            );

          fetch("/dummy_data/properties.json") // Change this to the correct properties JSON file if available
            .then((response) => response.json())
            .then((propertyData) => {
              setProperties(propertyData);
            })
            .catch((error) =>
              console.error("Error fetching properties:", error)
            );

          // Fetch token details if available
          fetch("/dummy_data/property_token.json") // Replace with actual token details JSON
            .then((response) => response.json())
            .then((tokenData) => {
              setTokenDetails(
                tokenData.filter((token) => token.userId === userData.id)
              ); // Filter if needed
            })
            .catch((error) =>
              console.error("Error fetching token details:", error)
            );
        }
      })
      .catch((error) => console.error("Error fetching user details:", error));
  }, [id]);

  if (!user) {
    return <div>Loading user details...</div>;
  }

  return (
    <div className="p-6">
      {/* First Row of Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* User Details Card */}
        <div className=" p-8 border rounded-xl shadow">
          <h3 className="text-xl font-medium mb-2 pb-6">
            {user.firstName} {user.lastName}
          </h3>

          <p className="flex items-center">
            <h3 className="font-medium text-gray-600 mr-4 pb-4">
              Mobile No (WA):
            </h3>
            <span className="pb-4">{user.mobileNoWa}</span>
          </p>
          <p className="flex items-center">
            <h3 className="font-medium text-gray-600 mr-4 pb-4">
              Mobile No (Calling)
            </h3>
            <span className="pb-4">{user.mobileNoCalling}</span>
          </p>
          <p className="flex items-center">
            <h3 className="font-medium text-gray-600 mr-4 pb-4">Email</h3>
            <span className="pb-4">{user.emailId}</span>
          </p>

          {address ? (
            <>
              <p className="flex items-center">
                <h3 className="font-medium text-gray-600 mr-4 pb-4">Type</h3>
                <span className="pb-4">{address.addressType}</span>
              </p>

              <p className="flex items-center">
                <h3 className="font-medium text-gray-600 mr-4 pb-4">Address</h3>
                <span className="pb-4">
                  {address.buildingNo} , {address.streetName1} ,
                  {address?.streetName2}
                  {address.city} , {address.district} , {address.pinCode} ,{" "}
                  {address.state} , {address.country}
                </span>
              </p>
            </>
          ) : (
            <p>Loading address details...</p>
          )}
        </div>

        {/* User Requirements & Property Details Card */}
        <div className="p-8 border rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-2 pb-6">Property Details</h3>

          {userRequirements.length > 0 ? (
            <>
              <ul>
                {userRequirements.map((requirement) => (
                  <li key={requirement.id} className="mb-2">
                    <p className="flex items-center">
                      <h3 className="font-medium text-gray-600 mr-4 pb-4">
                        Property Type:
                      </h3>
                      <span className="pb-4">{requirement.propertyType}</span>
                    </p>
                    <p className="flex items-center">
                      <h3 className="font-medium text-gray-600 mr-4 pb-4">
                        Sale Type:
                      </h3>
                      <span className="pb-4">
                        {requirement.propertySaleType}
                      </span>
                    </p>
                    <p className="flex items-center">
                      <h3 className="font-medium text-gray-600 mr-4 pb-4">
                        State:
                      </h3>
                      <span className="pb-4">{requirement.propertyState}</span>
                    </p>
                    <p className="flex items-center">
                      <h3 className="font-medium text-gray-600 mr-4 pb-4">
                        Size/BHK:
                      </h3>
                      <span className="pb-4">
                        {requirement.sizeBhk || "N/A"}
                      </span>
                    </p>
                    <p className="flex items-center">
                      <h3 className="font-medium text-gray-600 mr-4 pb-4">
                        Location:
                      </h3>
                      <span className="pb-4">{requirement.location}</span>
                    </p>
                    <hr className="my-2" />
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <p>No user requirements found.</p>
          )}
        </div>
      </div>

      {/* Second Row of Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
        {/* Visit Details Card */}
        <div className="border rounded-xl p-6 shadow">
          <h3 className="text-xl font-medium mb-6">Visit Details</h3>
          <div className="mb-4 pb-4">
            <h4 className="font-medium text-gray-600">
              Number of Visits: {visitDetails.length}
            </h4>
          </div>
          {visitDetails.length > 0 ? (
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="border px-4 py-2">Visit No</th>
                  <th className="border px-4 py-2">Visit Date</th>
                  <th className="border px-4 py-2">Visit Time</th>
                  <th className="border px-4 py-2">Agent</th>
                  <th className="border px-4 py-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {visitDetails.map((visit, index) => {
                  // Destructure the date and time
                  const visitDate = new Date(visit.visitSchedule);
                  const visitedDateTime = new Date(visit.visitedDateTime);

                  // Extract date and time
                  const visitDateString = visitDate.toLocaleDateString(); // Format: MM/DD/YYYY
                  const visitTimeString = visitDate.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  }); // Format: HH:MM AM/PM

                  const visitedDateTimeString =
                    visitedDateTime.toLocaleDateString(); // Format: MM/DD/YYYY
                  const visitedTimeString = visitedDateTime.toLocaleTimeString(
                    [],
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  ); // Format: HH:MM AM/PM

                  // Determine the visit status
                  const status = visit.visited ? "Completed" : "Scheduled";

                  return (
                    <tr key={visit.propertyId}>
                      <td className="border px-4 py-2 text-center">
                        {index + 1}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        {visitDateString}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        {visitTimeString}
                      </td>
                      <td className="border px-4 py-2 text-center">
                        Agent {index + 1}
                      </td>{" "}
                      {/* Dummy agent data */}
                      <td className="border px-4 py-2 text-center">{status}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>No visit details found.</p>
          )}
        </div>

        {/* Token Details Card */}
        <div className="border rounded-xl p-6 shadow">
          <h3 className="text-xl font-medium mb-2 pb-4">Token Details</h3>
          
          {tokenDetails.length > 0 ? (
            <ul>
              {tokenDetails.map((token) => (
                <li key={token.id} className="mb-2">
                  
                <p className="flex items-center">
                  <h3 className="font-medium text-gray-600 mr-4 pb-6">Token Amount:</h3>
                  <span className="pb-6">{token.tokenAmount}</span>
                </p>
                <p className="flex items-center">
                  <h3 className="font-medium text-gray-600 mr-4 pb-6">Details</h3>
                  <textarea className="pb-6 p-2 border rounded-lg">{token.details}</textarea>
                </p>
                <button
                    onClick={() => handleGenerateReceipt(token)}
                    className="mt-4  bg-blue-600 text-white py-2 px-4 rounded"
                  >
                    Generate Receipt
                  </button>
                <hr className="my-2" />
              </li>
              ))}
            </ul>
          ) : (
            <p>No token details found.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default UserDetails;
